import { observer } from 'mobx-react-lite'
import { firstError } from '@/features/legends/editor/validation'
import type { AnyFilterEditor } from '@/features/legends/filters/filter-registry'
import { FilterCard } from '@/features/legends/filters/components/FilterCard'
import { FilterEditorContainer } from '@/features/legends/filters/components/FilterEditorContainer'

export interface FilterCardContainerProps {
  vm: AnyFilterEditor
  isOnRail?: boolean
  isDisabled?: boolean
  onRemove?: () => unknown
  testId?: string
}

export const FilterCardContainer = observer(function FilterCardContainer({
  vm,
  isOnRail,
  isDisabled: isDisabledProp,
  onRemove,
  testId,
}: FilterCardContainerProps) {
  const isDisabled = vm.isEditingDisabled || isDisabledProp
  return (
    <FilterCard
      hasError={!!firstError(vm.validation)}
      isOnRail={isOnRail}
      onRemove={onRemove}
      isDisabled={isDisabled}
      testId={testId}
    >
      <FilterEditorContainer vm={vm} isDisabled={isDisabled} testId={testId} />
    </FilterCard>
  )
})
